// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_ms-0";